/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { useContext } from 'react';
import { NavLink } from 'react-router';
import {
  DIVI_PROGRESS_STATE_STORAGE_KEY,
  DiviNavigationIds,
  DiviProgress,
  DiviProgressStatesType,
} from '../../models/diviProgress';
import { LocalStorageContext } from '../../provider/LocalStorageProvider';
import StatusDoneIcon from '../../assets/images/icons/status-done.svg?react';
import StatusToDoIcon from '../../assets/images/icons/status-todo.svg?react';
import StatusTouchedIcon from '../../assets/images/icons/status-touched.svg?react';
import ErrorIcon from '@mui/icons-material/Error';
import { DiviNavigationSymbol } from './DiviNavigationSymbol';

interface DiviNavigationElementProps {
  id: DiviNavigationIds;
  route?: string;
  showNewDataStatusIcon?: boolean;
}

export function DiviNavigationElement(props: DiviNavigationElementProps) {
  const { id, route } = props;
  const state = useContext(LocalStorageContext).getData<DiviProgressStatesType>(DIVI_PROGRESS_STATE_STORAGE_KEY);

  return (
    <NavLink id={id} className={state?.[id] ?? DiviProgress.todo} to={route ? route : '/'}>
      <div className='divi-navigation-symbol-container'>
        <div className='divi-navigation-symbol-icon'>
          {state?.[id] === DiviProgress.done ? (
            <DiviNavigationSymbol tooltip='Vollständig'>
              <StatusDoneIcon />
            </DiviNavigationSymbol>
          ) : state?.[id] === DiviProgress.touched ? (
            <DiviNavigationSymbol tooltip='In Bearbeitung'>
              <StatusTouchedIcon />
            </DiviNavigationSymbol>
          ) : (
            <DiviNavigationSymbol tooltip='Zu bearbeiten'>
              <StatusToDoIcon />
            </DiviNavigationSymbol>
          )}
        </div>
        <div className='divi-navigation-symbol-icon'>
          {props.showNewDataStatusIcon && (
            <DiviNavigationSymbol tooltip='Neue Daten verfügbar'>
              <ErrorIcon color={'error'} />
            </DiviNavigationSymbol>
          )}
        </div>
      </div>
    </NavLink>
  );
}
